import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  getSelectedCustomerIdentActionState,
  LoadCustomerIdent,
  LoadCustomerIdentSuccess,
} from '@resident-nx/shared';
import { filter, firstValueFrom, map } from 'rxjs';
import { INFRASTRUCTURE_CONFIG } from '../../injection-tokens/infrastructure';

export function initializeCustomerIdent() {
  return () => {
    const store = inject(Store);
    const config = inject(INFRASTRUCTURE_CONFIG);
    const environmentCustomerIdent = config.environment.customerIdent;

    if (environmentCustomerIdent) {
      // only for local environment
      store.dispatch(LoadCustomerIdentSuccess({ customerIdent: environmentCustomerIdent }));
      return Promise.resolve(true);
    } else {
      store.dispatch(LoadCustomerIdent({ domain: window.location.host }));
      return firstValueFrom(
        store.select(getSelectedCustomerIdentActionState).pipe(
          filter(state => !state.pending),
          map(() => true)
        )
      );
    }
  };
}
